export default "__VITE_ASSET__aa19ac83__"